// Dependecies
import { useState, useEffect } from 'react';
import { reject } from 'lodash';
// Store
import userWorkShopRegister from '../../store/userWorkShopRegister';
import user from '../../store/user';

// Hooks
import useLanguage from '../useLanguage';

function useUserRegisterWorkshop(reset) {
  const { locale } = useLanguage();
  const [, userRegisterVenueActions] = userWorkShopRegister();
  const [userStore] = user();
  const [successfully, setSuccessfully] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [listUsers, setListUsers] = useState([]);
  const [driver, setDriver] = useState();
  const [messageErrorEmail, setMessageErrorEmail] = useState(false);
  const [messageErrorId, setMessageErrorId] = useState(false);
  const [reload, setReload] = useState(false);
  const [errorApi, setErrorApi] = useState(false);
  const [venues, setVenues] = useState([]);

  useEffect(() => {
    if (userStore.token) {
      userRegisterVenueActions.getVenues(userStore.token).then(
        (res) => {
          setVenues(res.listVenues);
        },
        (e) => {
          if (e.status === 401) {
            setReload(true);
            reject(e);
          }
        }
      );
    }
  }, [userStore.token, listUsers]);

  useEffect(() => {
    if (userStore.token) {
      setReload(true);
      userRegisterVenueActions.getUsers(userStore.token).then(
        (res) => {
          setListUsers(res.listUsers);
          setSuccessfully(false);
          setReload(true);
        },
        (e) => {
          if (e.status === 401) {
            setReload(true);
            reject(e);
          }
        }
      );
    }
  }, [userStore.token, successfully]);

  const submitAdd = (data) => {
    try {
      setMessageErrorEmail(false);
      setMessageErrorId(false);

      const dat = {
        ...data,
      };
      userRegisterVenueActions.add(dat, userStore.token, locale).then(
        (res) => {
          if (res.status === 200) {
            reset();
            setSuccessfully(true);
            setMessageErrorEmail(false);
            setMessageErrorId(false);
          }
          if (res.status === 400) {
            setMessageErrorEmail(true);
          }
          if (res.status === 401) {
            setMessageErrorId(true);
          }
        },
        (e) => {
          setErrorApi(e);
        }
      );
    } catch (error) {
      setErrorApi(error);
    }
  };

  const successfullyUpdate = () => {
    setSuccessfully(true);
    setOpenModal(false);
  };
  const closeModal = () => {
    setOpenModal(false);
  };
  const openModalEdit = (id) => {
    setOpenModal(false);

    userRegisterVenueActions.getUserId(userStore.token, id).then(
      (res) => {
        setDriver(res.userCompany);
        setOpenModal(true);
      },
      (e) => {
        if (e.status === 401) {
          reject(e);
        }
      }
    );
  };

  return {
    openModalEdit,
    closeModal,
    openModal,
    listUsers,
    driver,
    successfullyUpdate,
    submitAdd,
    messageErrorEmail,
    messageErrorId,
    reload,
    successfully,
    errorApi,
    venues,
  };
}

export default useUserRegisterWorkshop;
